const TWO_PI = 2 * Math.PI;

// --- Colors (1:1 from Apple/Android AIGlowColors — teal-dominant H=177° S=90%) ---
export const STRAND_COLORS = [
  '#51F6EE', // [0] TealLight   HSL(177, 90%, 64%)
  '#0AC2B9', // [1] Teal        HSL(177, 90%, 40%)
  '#0DF2E7', // [2] TealBright  HSL(177, 90%, 50%)
  '#60A5FA', // [3] BlueBright
  '#C084FC', // [4] PurpleLight
  '#34D399', // [5] Mint
  '#69F7F0', // [6] CyanLight   HSL(177, 90%, 69%)
  '#6366F1', // [7] Indigo
] as const;

// --- Animation timing (1:1 from Android GlowAnimation) ---
export const PHASE_DURATION_MS = 120_000;
export const OPACITY_PULSE_DURATION_MS = 3_500;
export const OPACITY_MIN = 0.88;
export const OPACITY_MAX = 1.0;

// --- Frame geometry (1:1 from Android FrameConfig) ---
export const FRAME_FRACTION = 0.15;
export const COMPACT_FRAME_FRACTION = 0.1;
export const BASE_WIDTH_FRACTION = 0.14;
export const STRAND_ALPHA = 0.92;
export const TRAVEL_SPEED = 1.0;
export const SEGMENTS = 7;
export const BLUR_FRACTION = 0.24;
export const CORNER_RADIUS_FRACTION = 0.7;

// --- Strand configs (1:1 from Android strandConfigs) ---
export interface StrandConfig {
  color: string;
  pointCount: number;
  arcLength: number;
  startOffset: number;
  speedMultiplier: number;
  widthMultiplier: number;
  waveFrequency: number;
  phaseOffset: number;
  amplitudeMultiplier: number;
}

export const STRAND_CONFIGS: readonly StrandConfig[] = [
  {
    color: STRAND_COLORS[0],
    pointCount: 72,
    arcLength: 0.75,
    startOffset: 0.0,
    speedMultiplier: 2,
    widthMultiplier: 1.0,
    waveFrequency: 3.0,
    phaseOffset: 0.0,
    amplitudeMultiplier: 1.0,
  },
  {
    color: STRAND_COLORS[3],
    pointCount: 64,
    arcLength: 0.62,
    startOffset: 0.13,
    speedMultiplier: 2,
    widthMultiplier: 1.5,
    waveFrequency: 3.5,
    phaseOffset: 0.79,
    amplitudeMultiplier: 0.9,
  },
  {
    color: STRAND_COLORS[4],
    pointCount: 76,
    arcLength: 0.8,
    startOffset: 0.25,
    speedMultiplier: 3,
    widthMultiplier: 0.7,
    waveFrequency: 2.7,
    phaseOffset: 1.57,
    amplitudeMultiplier: 1.15,
  },
  {
    color: STRAND_COLORS[1],
    pointCount: 60,
    arcLength: 0.58,
    startOffset: 0.4,
    speedMultiplier: 2,
    widthMultiplier: 1.3,
    waveFrequency: 3.2,
    phaseOffset: 2.36,
    amplitudeMultiplier: 0.85,
  },
  {
    color: STRAND_COLORS[6],
    pointCount: 68,
    arcLength: 0.72,
    startOffset: 0.52,
    speedMultiplier: 3,
    widthMultiplier: 0.85,
    waveFrequency: 3.8,
    phaseOffset: 3.14,
    amplitudeMultiplier: 1.1,
  },
  {
    color: STRAND_COLORS[7],
    pointCount: 56,
    arcLength: 0.55,
    startOffset: 0.65,
    speedMultiplier: 2,
    widthMultiplier: 1.6,
    waveFrequency: 2.5,
    phaseOffset: 3.93,
    amplitudeMultiplier: 0.92,
  },
  {
    color: STRAND_COLORS[2],
    pointCount: 80,
    arcLength: 0.82,
    startOffset: 0.78,
    speedMultiplier: 3,
    widthMultiplier: 0.8,
    waveFrequency: 3.3,
    phaseOffset: 4.71,
    amplitudeMultiplier: 1.08,
  },
  {
    color: STRAND_COLORS[5],
    pointCount: 66,
    arcLength: 0.66,
    startOffset: 0.9,
    speedMultiplier: 2,
    widthMultiplier: 1.35,
    waveFrequency: 3.0,
    phaseOffset: 5.5,
    amplitudeMultiplier: 0.95,
  },
] as const;

export { TWO_PI };
